// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"a4de1689","218":"3349eb67","244":"87648dd6","578":"dec4d35e","646":"0b5bc33d","665":"8f2152af","686":"81b11b42","710":"2c2063f7","825":"3ab250cd"}[chunkId] + ".chunk.js";
};